import { Component, Input } from '@angular/core';

@Component({
  selector: 'influencer-top-exposure-item-placeholder',
  templateUrl: './influencer-top-exposure-item-placeholder.component.html',
  styleUrls: ['./influencer-top-exposure-item-placeholder.component.scss']
})
export class InfluencerTopExposureItemPlaceholderComponent {
  @Input() name: string;
  @Input() printMode: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/influencer-top-exposures/influencer-top-exposure-item-placeholder/influencer-top-exposure-item-placeholder.component.ts